import React from 'react';
import clazz from 'classnames';
import GraphContainer from '../GraphContainer';
import genWatermark from '@/shared/waterMark';
import styles from './index.module.less';
import authIns from '@/shared/authz';
export default function GraphWrapper(props) {
    const { style = {}, className, title, config, height, isEmpty } = props;
    const authData = authIns.getAuthData();
    if (Object.keys(authData).length === 0) {
        return null;
    }
    const drawWatermarkBase64 = genWatermark({
        watermarkText: `${authData.displayName.substr(-2)}  ${authData.userPhone.substr(-4)}`,
    });
    return (<div className={clazz(styles['zhuge-graph'], className)} style={Object.assign({ backgroundImage: `url(${drawWatermarkBase64})` }, style)}>
      {title && <header>{title}</header>}

      <div className={styles['zhuge-graph-wrapper']}>
        <GraphContainer config={config} height={height} isEmpty={isEmpty}/>
      </div>
    </div>);
}
